import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import PlusCircleIcon from "../../../../../assets/Icons/PlusCircleIcon";
import ExMultiDropdown from "../../../../../components/basic-components/ExMultiDropdown";
import useLocations from "../../../../../utils/dropdown-options/useLocations";
import useIndustries from "../../../../../utils/dropdown-options/useIndustries";
import DeleteIcon from "../../../../../assets/Icons/DeleteIcon";
import UploadIcon from "../../../../../assets/Icons/UploadIcon";
import ExInput from "../../../../../components/basic-components/ExInput";
import CrossIcon from "../../../../../assets/Icons/CrossIcon";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { getMoreCandidateApi } from "../../../../../slices/aiSlice";
import React, { useEffect, useRef, useState } from "react";
import useSubIndustries from "../../../../../utils/dropdown-options/useSubIndustries";
import { toast } from "sonner";
import { unwrapResult } from "@reduxjs/toolkit";

const GlobalSearchForm = (props) => {
  const { locationsArray } = useLocations();
  const { industriesArray } = useIndustries();

  const globalSearchLocation = useAppSelector(
    (state) => state?.appConfig?.globalSearchLocation
  );
  const jobDetails = useAppSelector((state) => state.jobs.jobById.jobDetail);

  const { subIndustries } = useSubIndustries();

  const globalSearchSubIndustry = useAppSelector(
    (state) => state?.appConfig?.subIndustries
  );

  const form = useForm({
    defaultValues: {
      jobTitle: jobDetails?.title,
      specificCompany: [],
      location: [],
      industry: [],
      subIndustry: [],
      iterations: 2,
      clientCompany: jobDetails?.company,
      addPrompt: "",
      company_No: null,
    },
  });

  const { handleSubmit, control, formState, setValue } = form;
  const { errors } = formState;

  const [companyNo, specificCompany] = useWatch({
    control,
    name: ["company_No", "specificCompany"],
  });

  const { fields, append, remove } = useFieldArray({
    name: "targetCompanies",
    control,
  });

  const textareaRef = useRef(null);

  const handleInput = () => {
    const textarea = textareaRef.current;
    textarea.style.height = "auto"; // Reset height
    textarea.style.height = `${textarea.scrollHeight}px`; // Set to scroll height
  };

  const dispatch = useAppDispatch();

  const addOptionHandler = () => {
    append({ company: "" });
  };

  const onSubmit = async (formData) => {
    const resultString = formData?.industry?.map((obj) => obj.Name);
    const locations = formData?.locations?.map((obj) => obj.Title);
    const toastId = toast.loading("Fetching data...");
    props.onClose();
    try {
      const response = await dispatch(
        getMoreCandidateApi({
          industry: resultString,
          title: formData?.jobTitle,
          subIndustry: null,
          iterations: 2,
          Master_Excel_Path: null,
          addPrompt: formData.addPrompt,
          location: locations,
          clientCompany: formData.clientCompany,
          company_No: parseInt(formData.company_No),
          companyId: jobDetails.companyId,
          jobId: props.jobId,
          jobDetails: jobDetails.description,
        })
      ).then(unwrapResult);
      toast.dismiss(toastId);
      if (response.count === 0) toast.error("Candidates not found");
      else {
        toast.success("Candidates fetched successfully");
        props.onClose();
        //setShow(false);
        // getUserslist();
        //setSelectedFilter("latest");
      }
    } catch (error) {
      toast.dismiss(toastId);
      //toast.error("Something went wrong!");
      props.onClose();
    }
  };

  return (
    <div
      className="w-[60%] bg-exwhite-100 py-7 rounded-xl p-4 space-y-2"
      // style={{
      //   background: "linear-gradient(85.26deg, #2E82C7 21.55%, #42A5F6 93.37%)",
      // }}
    >
      <div className="flex items-center justify-between">
        <h1 className="text-exgray-300 text-lg font-semibold">
          Add More Candidate
        </h1>
        <div onClick={() => props.onClose()}>
          <CrossIcon />
        </div>
      </div>

      <form className="space-y-2" onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Controller
              name="clientCompany"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Hiring company is required",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <div>
                    <ExInput
                      id={"clientCompany"}
                      autoComplete="off"
                      placeholder="exotalent..etc"
                      onChange={onChange}
                      value={value || ""}
                      title={"Hiring Company"}
                      isMandatory={true}
                    />
                  </div>
                  {errors?.clientCompany?.message && (
                    <p className="text-red-400">
                      {errors?.clientCompany?.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          <div>
            <Controller
              name="jobTitle"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Job Title is required",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <div>
                    <ExInput
                      ///value={value}
                      id={"jobTitle"}
                      autoComplete="off"
                      placeholder="Job Title, keyword ... *"
                      onChange={onChange}
                      value={value}
                      title={"Job Title"}
                      isMandatory={true}
                    />
                  </div>
                  {errors?.jobTitle?.message && (
                    <p className="text-red-400">{errors?.jobTitle?.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center">
            <Controller
              name="company_No"
              control={control}
              rules={{
                required: !specificCompany
                  ? {
                      value: true,
                      message: "Company number required field",
                    }
                  : false,
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1 w-11/12">
                  <div>
                    <ExInput
                      id={"company_No"}
                      autoComplete="off"
                      placeholder=""
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          setValue("company_No", val); // only set if numeric
                        }
                      }}
                      //onChange={onChange}
                      value={value || ""}
                      title={"No. of Companies * (1-150)"}
                      inputMode="numeric"
                    />
                  </div>
                  {errors?.company_No?.message && (
                    <p className="text-red-400">
                      {errors?.company_No?.message}
                    </p>
                  )}
                </div>
              )}
            />
            <h1 className="text-exgray-600 mx-2 mt-6">OR</h1>
          </div>

          <div>
            <Controller
              name="specificCompany"
              control={control}
              rules={{
                required: !companyNo
                  ? {
                      value: true,
                      message:
                        "Target Company is required if Company No is not filled",
                    }
                  : false,
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <div>
                    <ExInput
                      id={"specificCompany"}
                      autoComplete="off"
                      placeholder=""
                      onChange={onChange}
                      value={value || ""}
                      title={"Target Companies"}
                      isMandatory={true}
                      disabled={companyNo ? true : false}
                    />
                  </div>
                  {errors?.specificCompany?.message && (
                    <p className="text-red-400">
                      {errors?.specificCompany?.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Controller
              name="industry"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Industries is required",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <div>
                    <ExMultiDropdown
                      title="Target Industries * (Multiple Selection)"
                      placeholder="Select"
                      onChange={onChange}
                      value={value || null}
                      optionValue="Id"
                      optionLabel="Name"
                      options={industriesArray}
                      dropDownHeight="auto"
                      dropDownBorderWidth="1px"
                      dropDownBorderColor="#8C8C8C"
                      error={errors?.departments?.message}
                      closeMenuOnSelect={false}
                    />
                  </div>
                  {errors?.industry?.message && (
                    <p className="text-red-400">{errors?.industry?.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div>
            <Controller
              name="subIndustry"
              control={control}
              rules={{
                required: {
                  value: false,
                  message: "SubIndustries is required",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <div>
                    <ExMultiDropdown
                      title="Target Sub Industries (Multiple Selection)"
                      placeholder="Select"
                      onChange={onChange}
                      value={value || null}
                      optionValue="Id"
                      optionLabel="Title"
                      options={subIndustries}
                      dropDownHeight="auto"
                      dropDownBorderWidth="1px"
                      dropDownBorderColor="#8C8C8C"
                      error={errors?.departments?.message}
                      closeMenuOnSelect={false}
                    />
                  </div>
                  {errors?.subIndustry?.message && (
                    <p className="text-red-400">
                      {errors?.subIndustry?.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Controller
              name="addPrompt"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Promt is required",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <label
                    htmlFor={"promt"}
                    className={`text-exgray-200/70 text-base font-semibold`}
                  >
                    Prompt *
                  </label>
                  <div>
                    <textarea
                      id="addPrompt"
                      className="border border-exgray-300 rounded-md"
                      ref={textareaRef}
                      onChange={onChange}
                      onInput={handleInput}
                      placeholder="Type something..."
                      rows={1}
                      style={{
                        width: "100%",
                        resize: "none",
                        overflow: "hidden",
                        lineHeight: "1.5em",
                        padding: "8px",
                      }}
                    />
                    <h1 className="text-exgray-300 text-xs">
                      * Provide additional specifications/ requirements for
                      better and accurate result.
                    </h1>
                  </div>
                  {errors?.addPrompt?.message && (
                    <p className="text-red-400">{errors?.addPrompt?.message}</p>
                  )}
                </div>
              )}
            />
          </div>
          <div>
            <Controller
              name="locations"
              control={control}
              rules={{
                required: {
                  value: false,
                  message: "Job Title is required",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <div className="space-y-1">
                  <div>
                    <ExMultiDropdown
                      title="Locations(Multiple Selection)"
                      placeholder="Select"
                      onChange={onChange}
                      value={value || null}
                      optionValue="Id"
                      optionLabel="Name"
                      options={locationsArray}
                      dropDownHeight="auto"
                      dropDownBorderWidth="1px"
                      dropDownBorderColor="#8C8C8C"
                      error={errors?.locations?.message}
                      closeMenuOnSelect={false}
                    />
                  </div>
                  {errors?.locations?.message && (
                    <p className="text-red-400">{errors?.locations?.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        </div>
        <div className="flex items-center justify-center">
          <button
            type="submit"
            className="border border-exwhite-100 rounded-lg px-12 py-2 text-center text-base font-semibold text-exwhite-100 bg-secondary-400 hover:bg-secondary-500 hover:text-exwhite-100 "
          >
            Search
          </button>
        </div>
      </form>
    </div>
  );
};

export default GlobalSearchForm;
